/**
 * NavBarSiteContainer.js
 * Styled Component for the Logo and SiteName Container
 */
import styled from "styled-components";

// Styles
const NavBarSiteContainer = styled.div`
    margin: 0 0 0 10px;
    display: flex;
    align-items: center;
`

export default NavBarSiteContainer;